import { Box } from 'braid-design-system';

import { IconCertifiedSvg } from './IconCertifiedSvg';

import * as styles from './IconCertified.css';

interface Props {
  color?: string;
}

export const IconCertified = (props: Props) => (
  <Box
    component={IconCertifiedSvg}
    role="img"
    color={props.color}
    className={styles.alignToNonBraidIcons}
  />
);
